interface CostSummaryProps {
  estimatedCost: string;
  estimatedQuantity: string;
  baseCurrency: string;
  quoteCurrency: string;
  minOrderSize: string | undefined;
  nonMarginBuyingPower: string | undefined;
  isUsdPair: boolean;
}

export const CostSummary = ({
  estimatedCost,
  estimatedQuantity,
  baseCurrency,
  quoteCurrency,
  minOrderSize,
  nonMarginBuyingPower,
  isUsdPair,
}: CostSummaryProps) => (
  <div className="flex flex-col gap-1 py-2">
    <div className="flex items-center justify-between gap-2">
      <p className="m-0 shrink-0 p-0 font-medium text-gray-700 text-sm">
        Estimated{" "}
        <span className="underline decoration-[14%] decoration-dotted underline-offset-[25%] [text-decoration-skip-ink:none]">
          {quoteCurrency}
        </span>
      </p>
      <p className="m-0 min-w-0 break-all p-0 text-right font-medium font-mono text-base text-gray-700 leading-[22px]">
        {isUsdPair && "$"}
        {estimatedCost}
      </p>
    </div>
    <div className="flex items-center justify-between gap-2">
      <p className="m-0 shrink-0 p-0 text-gray-600 text-xs">
        Estimated{" "}
        <span className="underline decoration-[14%] decoration-dotted underline-offset-[25%] [text-decoration-skip-ink:none]">
          {baseCurrency}
        </span>
      </p>
      <p className="m-0 min-w-0 break-all p-0 text-right font-medium font-mono text-gray-700 text-xs">
        {estimatedQuantity}
      </p>
    </div>

    {isUsdPair && (
      <div className="flex items-center justify-between gap-2">
        <p className="m-0 shrink-0 p-0 text-gray-600 text-xs">
          Non-Margin Buying Power
        </p>
        <p className="m-0 min-w-0 break-all p-0 text-right font-medium font-mono text-gray-700 text-xs">
          {nonMarginBuyingPower}
        </p>
      </div>
    )}

    {minOrderSize && (
      <div className="flex items-center justify-between gap-2">
        <p className="m-0 shrink-0 p-0 text-gray-600 text-xs">
          Min. Order Size
        </p>
        <p className="m-0 min-w-0 break-all p-0 text-right font-medium font-mono text-gray-700 text-xs">
          {minOrderSize} {baseCurrency}
        </p>
      </div>
    )}
  </div>
);
